var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWallet = function SvgWallet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23 19"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2,
    stroke: "inherit",
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "square"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 4.8H3c-1.1 0-2-.9-2-2v13.3c0 1 .9 1.9 2 1.9h17c1.1 0 2-.8 2-1.9V6.7c0-1-.9-2-2-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 6.7V2.9c0-1-.9-1.9-2-1.9H3c-1.1 0-2 .8-2 1.9m17.2 8.5h0"
  }))));
};
export default SvgWallet;